import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import { AllJobTitlesQuery, JobTitlesFilter } from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'JobRoleSelect',
  props: {
  multiple: {
    type: Boolean,
    default: false,
  },
  filter: {
    type: Object,
    default: () => ({}),
  },
  staffable: {
    type: Boolean,
    default: undefined,
  },
  returnObject: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props



const useFilter = computed<JobTitlesFilter>(() => ({
  staffable: props.staffable,
  ...props.filter,
}))

return { __sfc: true,props, useFilter, AllJobTitlesQuery }
}

})